import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@campaign-landing/not-auth').then((m) => m.LandingNotAuthModule),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
